import { Button } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BasicModal } from '../../../components';

interface IGiveupActionProps {
  onGiveUp: () => void;
}

const GiveupAction = ({ onGiveUp }: IGiveupActionProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const { t } = useTranslation();

  const onClickAccept = () => {
    setOpen(false);
    onGiveUp();
  };

  return (
    <div>
      <Button
        onClick={() => {
          setOpen(true);
        }}
        color='primary'
        variant='contained'
      >
        {t('pages.pqrs.actions.giveUp.title')}
      </Button>
      <BasicModal
        open={open}
        title='Desistimiento voluntario '
        showAcceptButton
        showCancelButton
        titleButtonCancel={t('pages.pqrs.actions.giveUp.btnNon')}
        titleButtonAccept={t('pages.pqrs.actions.giveUp.btnYes')}
        onClickCancel={() => {
          setOpen(false);
        }}
        onClickAccept={onClickAccept}
      >
        <div className='text-2xl italic'>
          {t('pages.pqrs.actions.giveUp.message')}
        </div>
      </BasicModal>
    </div>
  );
};
export default GiveupAction;
